function get(params) {
  return this.axios.get('/review', { params })
}

const review = (axios) => ({ axios, get })

export default review
